import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      data-testid="theme-toggle"
      className="p-2 rounded-full border-2 border-black dark:border-white bg-white dark:bg-[#2D2A26] hover:bg-[#F0F0F0] dark:hover:bg-[#3D3A36] transition-all hard-shadow-hover"
      aria-label="Toggle theme"
    >
      {isDark ? (
        <Sun className="w-5 h-5 text-[#FFE66D]" strokeWidth={2.5} />
      ) : (
        <Moon className="w-5 h-5" strokeWidth={2.5} />
      )}
    </button>
  );
};

export default ThemeToggle;